/**
 * Aero Popup Trigger
 * Manages timed popups with configurable date ranges and page exclusions
 */

(function() {
  'use strict';

  // ============================================================================
  // CONFIGURATION - Edit these settings to customize popup behavior
  // ============================================================================

  // ════════════════════════════════════════════════════════════════════════════
  // POPUP 1 CONFIGURATION
  // ════════════════════════════════════════════════════════════════════════════
  // First popup settings (uses .popup, .popup-content, .overlay-popup classes)
  // ════════════════════════════════════════════════════════════════════════════

  const popup1Config = {
    // Set to true to always show popup (ignores date range)
    // Set to false to disable popup completely (will not show even if date is in range)
    alwaysShow: false,
    
    // Date range (JavaScript months are 0-indexed: 0=Jan, 1=Feb, ..., 11=Dec)
    // Note: Date range is currently not used - popup only shows if alwaysShow is true
    startDate: new Date(2025, 11, 20),  // December 24th, 2025
    endDate: new Date(2026, 0, 5),   // January 5th, 2026
    
    // Pages to EXCLUDE from showing popup (add/remove paths as needed)
    excludedPages: [
      '/collections/shops',
      '/products/',
      '/pages/seasonal-allergies',
      '/pages/pharmacy-pre-registration-form',
      '/pages/redirect-to-form'
    ],
    
    // Set to true to show popup every time (ignores cooldown)
    bypassCooldown: false,
    
    // Time between popup shows (in minutes)
    // Only used if bypassCooldown is false
    cooldownMinutes: 10,
    
    // LocalStorage key for tracking last shown time
    storageKey: 'lastShownPopup',
    
    // CSS selectors
    selectors: {
      popup: '.popup',
      content: '.popup-content',
      overlay: '.overlay-popup',
      source: '.for-call-popup',
      button: '[data-popup-close="1"]',
      closeBtn: '.popup-close-btn'
    }
  };

  // ════════════════════════════════════════════════════════════════════════════
  // POPUP 2 CONFIGURATION
  // ════════════════════════════════════════════════════════════════════════════
  // Second popup settings (uses .popup-announcement, .popup-content-announcement, etc.)
  // ════════════════════════════════════════════════════════════════════════════

  const popup2Config = {
    // Set to true to always show popup (ignores date range)
    // Set to false to disable popup completely (will not show even if date is in range)
    alwaysShow: false,
    
    // Date range (JavaScript months are 0-indexed: 0=Jan, 1=Feb, ..., 11=Dec)
    // Note: Date range is currently not used - popup only shows if alwaysShow is true
    startDate: new Date(2025, 11, 20),  // December 24th, 2025
    endDate: new Date(2026, 0, 5),    // January 5th, 2026
    
    // Pages to EXCLUDE from showing popup (add/remove paths as needed)
    excludedPages: [
      '/collections/shops',
      '/products/',
      '/pages/seasonal-allergies',
      '/pages/pharmacy-pre-registration-form',
      '/pages/redirect-to-form'
    ],
    
    // Set to true to show popup every time (ignores cooldown)
    bypassCooldown: false,
    
    // Time between popup shows (in minutes)
    // Only used if bypassCooldown is false
    cooldownMinutes: 10,
    
    // LocalStorage key for tracking last shown time
    storageKey: 'lastShownPopup2',
    
    // CSS selectors
    selectors: {
      popup: '.popup-announcement',
      content: '.popup-content-announcement',
      overlay: '.overlay-popup-announcement',
      source: '.for-call-popup-announcement',
      button: '[data-popup-close="2"]',
      closeBtn: '.popup-close-btn-announcement'
    }
  };

  // ============================================================================
  // POPUP CLASS - Reusable popup controller
  // ============================================================================

  /**
   * Popup Class
   * Handles opening, closing, and overlay interactions for popups
   */
  function Popup(config) {
    var $ = window.jQuery || window.$;
    if (!$) {
      console.error('Aero Popup Trigger: jQuery is required for Popup class');
      return;
    }
    
    this.popup = $(config.popup);
    this.content = $(config.content);
    this.overlay = $(config.overlay);
    var pop = this;
    var $jq = $; // Store jQuery reference for use in methods

    this.open = function(content) {
      // Only replace content inside .for-call-popup, preserving the close button
      var contentContainer = pop.content.find('.for-call-popup, .for-call-popup-announcement');
      if (contentContainer.length > 0) {
        contentContainer.html(content);
      } else {
        // Fallback: if container not found, replace entire content (old behavior)
        pop.content.html(content);
      }
      pop.popup.addClass('open').fadeIn(1000);
      pop.overlay.addClass('open');
    };

    this.close = function() {
      pop.popup.removeClass('open');
      pop.overlay.removeClass('open');
      // Reset the popup shown flag when popup is closed
      if (typeof window.aeroPopupShown !== 'undefined') {
        window.aeroPopupShown = false;
      }
    };

    // Close popup when clicking overlay
    this.overlay.on('click', function(e) {
      if (!pop.popup.is(e.target) && pop.popup.has(e.target).length === 0) {
        pop.close();
      }
    });
  }

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================

  /**
   * Check if current page should be excluded
   * @param {Array} excludedPages - Array of page paths to exclude
   * @returns {boolean} - True if page should be excluded
   */
  function isPageExcluded(excludedPages) {
    var currentPath = window.location.pathname;
    return excludedPages.some(function(path) {
      return currentPath.indexOf(path) !== -1;
    });
  }

  /**
   * Check if enough time has passed since last popup show
   * @param {string} storageKey - LocalStorage key
   * @param {number} cooldownMinutes - Minutes to wait between shows
   * @returns {boolean} - True if popup can be shown
   */
  function canShowPopup(storageKey, cooldownMinutes) {
    var lastShown = localStorage.getItem(storageKey);
    var currentTime = new Date().getTime();
    var cooldownMs = cooldownMinutes * 60 * 1000; // Convert minutes to milliseconds

    if (!lastShown) {
      return true; // Never shown before
    }

    return (currentTime - parseInt(lastShown, 10)) > cooldownMs;
  }

  /**
   * Check if current date is within popup date range
   * @param {Date} startDate - Start date
   * @param {Date} endDate - End date
   * @returns {boolean} - True if current date is in range
   */
  function isDateInRange(startDate, endDate) {
    var now = new Date();
    // Reset time to midnight for accurate date comparison
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    
    return today >= start && today <= end;
  }

  // Track if a popup has been shown to prevent multiple popups
  // Use window object to make it accessible across scopes
  window.aeroPopupShown = false;

  /**
   * Show popup with given configuration
   * @param {Object} config - Popup configuration object
   * @param {string} popupName - Name of popup for debugging (e.g., "Popup 1")
   * @returns {boolean} - Returns true if popup will be shown, false otherwise
   */
  function showPopup(config, popupName) {
    // Wait for jQuery and DOM to be ready
    if (typeof jQuery === 'undefined') {
      console.error('Aero Popup Trigger: jQuery is not loaded. Please ensure jQuery is loaded before this script.');
      return false;
    }

    var willShowPopup = false;

    jQuery(function($) {
      // Check if another popup has already been shown
      if (window.aeroPopupShown) {
        console.log('Aero Popup Trigger: ' + popupName + ' - Another popup already displayed, skipping');
        return;
      }

      // Check if page should be excluded
      if (isPageExcluded(config.excludedPages)) {
        console.log('Aero Popup Trigger: ' + popupName + ' - Page excluded:', window.location.pathname);
        return;
      }

      // Check cooldown (skip if bypassCooldown is true)
      if (!config.bypassCooldown && !canShowPopup(config.storageKey, config.cooldownMinutes)) {
        console.log('Aero Popup Trigger: ' + popupName + ' - Still in cooldown period');
        return;
      }

      // Mark that we will show a popup
      willShowPopup = true;
      window.aeroPopupShown = true;

      // Wait a bit longer to ensure all DOM elements are loaded
      setTimeout(function() {
        // Check if popup elements exist
        var sourceContent = $(config.selectors.source);
        var popupElement = $(config.selectors.popup);
        
        if (sourceContent.length === 0) {
          console.warn('Aero Popup Trigger: ' + popupName + ' - Source element not found: ' + config.selectors.source);
          console.warn('Aero Popup Trigger: Make sure the popup HTML snippet is included in your theme.');
          window.aeroPopupShown = false; // Reset flag if element not found
          return;
        }

        if (popupElement.length === 0) {
          console.warn('Aero Popup Trigger: ' + popupName + ' - Popup container not found: ' + config.selectors.popup);
          window.aeroPopupShown = false; // Reset flag if element not found
          return;
        }

        // Initialize popup
        var popup = new Popup({
          popup: config.selectors.popup,
          content: config.selectors.content,
          overlay: config.selectors.overlay
        });

        // Open popup with content
        popup.open(sourceContent.html());

        // Set up close button click handlers
        // Use event delegation to handle buttons that may be dynamically inserted
        // Buttons have native keyboard support (Enter/Space), so no need for extra handlers
        $(config.selectors.content).on('click', config.selectors.button, function() {
          popup.close();
        });

        // Also support legacy close button selector if it exists
        if ($(config.selectors.closeBtn).length > 0) {
          $(config.selectors.closeBtn).on('click', function() {
            popup.close();
          });
        }

        // Save current time to localStorage
        localStorage.setItem(config.storageKey, new Date().getTime());
        
        console.log('Aero Popup Trigger: ' + popupName + ' - Popup displayed successfully');
      }, 500); // Increased timeout to ensure DOM is fully loaded
    });

    return willShowPopup;
  }

  // ============================================================================
  // INITIALIZATION
  // ============================================================================

  // ════════════════════════════════════════════════════════════════════════════
  // INITIALIZATION WITH PRIORITY SYSTEM
  // ════════════════════════════════════════════════════════════════════════════
  // Popup 1 has priority over Popup 2
  // Only one popup will show at a time
  // When alwaysShow is false, popup will NOT show even if date is in range
  
  // Check Popup 1 eligibility
  // If alwaysShow is true, show it. If false, don't show (regardless of date range).
  var popup1DateInRange = isDateInRange(popup1Config.startDate, popup1Config.endDate);
  var popup1ShouldShow = popup1Config.alwaysShow; // Only show if alwaysShow is true
  
  console.log('Aero Popup Trigger: Popup 1 - Always show:', popup1Config.alwaysShow,
              'Date in range:', popup1DateInRange,
              'Should show:', popup1ShouldShow,
              'Start:', popup1Config.startDate.toLocaleDateString(), 
              'End:', popup1Config.endDate.toLocaleDateString());
  
  // Check Popup 2 eligibility (only if Popup 1 doesn't show)
  // If alwaysShow is true, show it. If false, don't show (regardless of date range).
  var popup2DateInRange = isDateInRange(popup2Config.startDate, popup2Config.endDate);
  var popup2ShouldShow = popup2Config.alwaysShow; // Only show if alwaysShow is true
  
  console.log('Aero Popup Trigger: Popup 2 - Always show:', popup2Config.alwaysShow,
              'Date in range:', popup2DateInRange,
              'Should show:', popup2ShouldShow,
              'Start:', popup2Config.startDate.toLocaleDateString(),
              'End:', popup2Config.endDate.toLocaleDateString());
  
  // Priority: Popup 1 first, Popup 2 only if Popup 1 doesn't show
  if (popup1ShouldShow) {
    var popup1Shown = showPopup(popup1Config, 'Popup 1');
    if (!popup1Shown && popup2ShouldShow) {
      // Popup 1 was eligible but didn't show (e.g., page excluded), try Popup 2
      console.log('Aero Popup Trigger: Popup 1 eligible but not shown, trying Popup 2');
      showPopup(popup2Config, 'Popup 2');
    }
  } else if (popup2ShouldShow) {
    // Popup 1 not eligible, show Popup 2
    showPopup(popup2Config, 'Popup 2');
  } else {
    console.log('Aero Popup Trigger: No popups are eligible to show');
  }

})();